import { render, staticRenderFns } from "./ComponentNoticeBox.vue?vue&type=template&id=a0e7865c&"
import script from "./ComponentNoticeBox.vue?vue&type=script&lang=ts&"
export * from "./ComponentNoticeBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports